import { useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import SummaryNotAvailableIcon from "../../../../assets/images/not available.png";
import { APP_COLORS } from "../../../../enums";

export default function MeetingSummary({ data }) {
  const summaryKeys = useMemo(() => {
    const keys = Object.keys(data ?? {});
    const orderedKeys = ["Meeting Recap", "Next Steps"].filter((key) =>
      keys.includes(key)
    );
    const otherKeys = keys.filter((key) => !orderedKeys.includes(key));
    return [...orderedKeys, ...otherKeys];
  }, [data]);
  const [activeTab, setActiveTab] = useState(summaryKeys[0] ?? "");

  useEffect(() => {
    if (!summaryKeys.length) {
      setActiveTab("");
      return;
    }
    if (!activeTab || !summaryKeys.includes(activeTab)) {
      setActiveTab(summaryKeys[0]);
    }
  }, [activeTab, summaryKeys]);

  if (!Object.keys(data ?? {}).length) {
    return (
      <Grid item xs={12}>
        <Stack justifyContent="center" mt={10} alignItems="center">
          <img src={SummaryNotAvailableIcon} alt="Meeting summary not available" />
          <Typography variant="body-ibmPlexMono" color={APP_COLORS.textLight2}>
            Meeting summary not available for this recording
          </Typography>
        </Stack>
      </Grid>
    );
  }

  const activeItems = activeTab ? data?.[activeTab] ?? [] : [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ToggleButtonGroup
          size="small"
          value={activeTab}
          exclusive
          fullWidth
          onChange={(_, value) => {
            if (value) {
              setActiveTab(value);
            }
          }}
          aria-label="Meeting summary sections"
          sx={(theme) => ({
            width: "100%",
            borderRadius: "10px",
            backgroundColor: APP_COLORS.greyLight2,
            p: .5,
            "& .MuiToggleButton-root": {
              flex: 1,
              backgroundColor: APP_COLORS.greyLight2,
              border: 0
            },
            "& .MuiToggleButton-root.Mui-selected": {
              backgroundColor: 'primary.main',
              color: APP_COLORS.white,
              borderRadius: 2,
            },
          })}
        >
          {summaryKeys.map((key) => (
            <ToggleButton key={key} value={key}>
              {key}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
      <Grid item xs={12} height={350} overflow="auto">
        {activeItems.length ? (
          <Stack component="ul" pl={2} m={0} gap={2}>
            {activeItems.map((item, index) => (
              <Typography key={index} component="li" variant="body-ibmPlexMono">
                {item}
              </Typography>
            ))}
          </Stack>
        ) : (
          <Typography variant="body2">No summary details available.</Typography>
        )}
      </Grid>
    </Grid>
  );
}
